export default "__VITE_ASSET__gVD2x3dN__"